import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShieldAlert, LogOut, RefreshCw } from "lucide-react";

export default function AccessPending() {
  const { user, logout, refresh } = useAuth();
  const navigate = useNavigate();
  const suspended = user?.attorney_status === "suspended";

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-navy cr-grain">
      <div className="max-w-md w-full bg-white rounded-3xl p-8 text-center shadow-2xl cr-fade-up">
        <div className="h-16 w-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto">
          <ShieldAlert className="w-8 h-8 text-amber-500" />
        </div>
        <h1 className="mt-5 font-heading text-2xl font-extrabold text-navy">
          {suspended ? "Access Suspended" : "Approval Pending"}
        </h1>
        <p className="mt-3 text-slate-600 leading-relaxed">
          {suspended
            ? "Your attorney access has been suspended by an administrator. Please contact the Crash Ready team to restore access."
            : "Your account is awaiting administrator approval. You'll be able to access the attorney portal once an admin grants you access."}
        </p>
        <div className="mt-7 flex flex-col gap-3">
          <button onClick={() => refresh()} data-testid="recheck-access" className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-cobalt text-white font-medium hover:bg-cobalt-hover transition-all active:scale-[0.99]">
            <RefreshCw className="w-4 h-4" /> Check again
          </button>
          <button onClick={doLogout} data-testid="pending-logout" className="flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white border border-slate-200 text-slate-700 font-medium hover:bg-slate-50 transition-all">
            <LogOut className="w-4 h-4" /> Log out
          </button>
        </div>
        <p className="mt-6 text-xs text-slate-400">Signed in as {user?.email}</p>
      </div>
    </div>
  );
}
